import { StaticDashboard } from '@/components/metabase/StaticDashboard';
import { FC } from 'react';
import InlineToast from '@/components/toasts/inline';
import useMetabase from '@/hooks/use-metabase';

interface Props {
  name: string;
}

export const GroupInsights: FC<Props> = ({ name }) => {
  const { dashboards } = useMetabase();
  const { id: dashboardId, isValid: isDashboardValid } = dashboards.userGroupLg;
  if (!isDashboardValid) {
    return <InlineToast message="These insights are temporarily unavailable" level="info" />;
  }
  return (
    <StaticDashboard
      dashboardId={dashboardId}
      initialParameters={{ group: name }}
      hiddenParameters={['email', 'group']}
      isDrawer
    />
  );
};

export default GroupInsights;
